import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetUser } from '../services/Users/GetUser';
import { GetUserInterface } from '../types/getUserInterface';

export const useUserInfoStore = defineStore('userInfo', () => {
  const userInfo = ref<GetUserInterface>({
    id: null,
    userName: '',
    firstName: '',
    lastName: '',
    profileImageUrl: '',
    defaultProfileImageUrl: '',
    dashboardType: '',
    employeeStatus: null,
    securityGroupId: null, // AccessLevelId
    hasInsight: false,
    hasPulse: false,
    hasAnything: false,
    isOrgChartVisible: false,
    biometricId: null,
    companyId: ''
  });

  const getUser = async () => {
    const response: GetUserInterface = await GetUser();
    userInfo.value = response;
  };
  const getUserResponse = async () => {
    const response:GetUserInterface = await GetUser();
    return response;
  };

  return {
    userInfo,
    getUser,
    getUserResponse,
  };
});
